export type VisualCue =
  | "banner"
  | "curtain"
  | "logo_overlay"
  | "lateral_banner"
  | "sponsor_overlay";

export const VISUAL_CUE_OPTIONS: {
  value: VisualCue | "";
  label: string;
}[] = [
  { value: "", label: "None" },
  { value: "banner", label: "Banner" },
  { value: "curtain", label: "Curtain" },
  { value: "logo_overlay", label: "Logo overlay" },
  { value: "sponsor_overlay", label: "Sponsor overlay" },
  { value: "lateral_banner", label: "Lateral banner" },
];

export const VISUAL_CUE_CHIP_COLORS: Record<
  string,
  "default" | "primary" | "secondary" | "warning"
> = {
  curtain: "primary",
  banner: "secondary",
  logo_overlay: "warning",
  sponsor_overlay: "warning",
  lateral_banner: "secondary",
};

export function visualCueLabel(cue?: VisualCue | null): string {
  if (!cue) return "None";
  return VISUAL_CUE_OPTIONS.find((o) => o.value === cue)?.label ?? cue;
}
